export const getVenetieData = () => ({
  name: "Vénétie",
  country: "Italie",
  description: "La Vénétie est la plus grande région viticole d'Italie, célèbre pour son Prosecco, ses vins rouges Valpolicella et ses blancs Soave.",
  type: "region",
  mapAreas: [
    { region: "Vénétie", x: 55, y: 50, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "84,000 ha",
    production: "8,500,000 hl",
    wineries: "2,000+ domaines",
    villages: "30+ communes",
    exportPercentage: "80%"
  },
  characteristics: {
    climate: "Climat continental tempéré, influence adriatique",
    soil: "Sols calcaires, argileux, volcaniques",
    viticulture: "Pergolas traditionnelles, vendanges mécaniques et manuelles"
  },
  wineStyles: {
    red: "Rouges fruités et souples (Valpolicella, Amarone)",
    white: "Blancs secs et aromatiques (Soave, Pinot Grigio)",
    sparkling: "Prosecco, méthode Charmat"
  },
  history: "La Vénétie produit du vin depuis l'époque romaine. Le Prosecco est devenu le vin effervescent le plus vendu au monde.",
  foodPairing: "Risotto, polenta, poissons de l'Adriatique, fromages affinés, antipasti",
  subregions: {
    "valpolicella": {
      name: "Valpolicella",
      area: "8,000 ha",
      percentage: "9.5%",
      description: "Amarone et Valpolicella",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols calcaires et argileux",
        viticulture: "Pergolas traditionnelles"
      },
      grapeVarieties: {
        red: ["Corvina", "Rondinella", "Molinara"],
        white: ["Garganega", "Trebbiano"]
      },
      wineStyles: {
        red: "Rouges fruités et souples",
        dessert: "Amarone, Recioto"
      },
      foodPairing: "Risotto, polenta, fromages affinés"
    },
    "soave": {
      name: "Soave",
      area: "7,000 ha",
      percentage: "8.3%",
      description: "Vins blancs de qualité",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols volcaniques",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Garganega", "Trebbiano di Soave"]
      },
      wineStyles: {
        white: "Blancs secs et aromatiques"
      },
      foodPairing: "Poissons, fruits de mer, fromages frais"
    },
    "prosecco": {
      name: "Prosecco",
      area: "24,000 ha",
      percentage: "28.6%",
      description: "Vins effervescents",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols calcaires",
        viticulture: "Méthode Charmat"
      },
      grapeVarieties: {
        white: ["Glera"]
      },
      wineStyles: {
        sparkling: "Effervescents légers et fruités"
      },
      foodPairing: "Aperitifs, antipasti, desserts légers"
    },
    "bardolino": {
      name: "Bardolino",
      area: "2,500 ha",
      percentage: "3.0%",
      description: "Vins rouges légers",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols morainiques",
        viticulture: "Vendanges mécaniques"
      },
      grapeVarieties: {
        red: ["Corvina", "Rondinella", "Molinara"]
      },
      wineStyles: {
        red: "Rouges légers et fruités"
      },
      foodPairing: "Pâtes légères, poissons, fromages frais"
    },
    "conegliano-valdobbiadene": {
      name: "Conegliano-Valdobbiadene",
      area: "6,000 ha",
      percentage: "7.1%",
      description: "Prosecco Superiore",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols calcaires et argileux",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Glera"]
      },
      wineStyles: {
        sparkling: "Prosecco Superiore DOCG"
      },
      foodPairing: "Aperitifs, sushis, desserts"
    }
  },
  grapeVarieties: [
    { name: "Glera", percentage: "35%", description: "Cépage du Prosecco" },
    { name: "Corvina", percentage: "20%", description: "Cépage principal de Valpolicella" },
    { name: "Garganega", percentage: "15%", description: "Cépage blanc de Soave" },
    { name: "Pinot Grigio", percentage: "12%", description: "Cépage blanc international" },
    { name: "Rondinella", percentage: "8%", description: "Cépage d'assemblage" },
    { name: "Autres", percentage: "10%", description: "Cépages mineurs" }
  ]
}); 